function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "-25.91999999999996 0 648 648",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M259,310.7c54.3,0,106.1,20.7,144.9,51.7h10.3h28.4c-31.1-31.1-72.5-57-116.5-67.3c51.7-25.9,85.4-77.6,85.4-139.8   C411.6,69.9,341.8,0,256.3,0S100.9,69.8,100.9,155.3c0,62.1,36.2,113.9,85.4,139.8C80.2,323.6,0,424.5,0,543.6v77.6h310.6v-25.9   H26.1v-51.7C26.1,414.3,129.6,310.7,259,310.7z M129.6,155.4c0-72.5,57-129.4,129.4-129.4s129.4,57,129.4,129.4   s-57,129.4-129.4,129.4S129.6,227.9,129.6,155.4z",
    style: {
      fill: "rgb(0, 177, 64)"
    },
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "595.5,543.6 517.9,543.6 517.9,466 491.9,466 491.9,543.6 414.3,543.6 414.3,569.5 491.9,569.5 491.9,647.2    517.9,647.2 517.9,569.5 595.5,569.5  ",
    style: {
      fill: "rgb(0, 177, 64)"
    },
    vectorEffect: "non-scaling-stroke"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add-person.604e0ca0.svg";
export { ForwardRef as ReactComponent };